import { Skeleton } from '@accure/ui';

import { FullPageContent } from '@/components/layout/full-page-content';

export function SitesLoading() {
  return (
    <FullPageContent scrollable className="space-y-6 bg-zinc-50 p-4">
      <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
        Projects
      </h2>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(16rem,24rem))] gap-4">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="flex w-full flex-col gap-4 rounded-lg bg-white p-6 shadow-sm transition-shadow hover:shadow-md"
          >
            <Skeleton className="h-6 w-2/3" />

            <div className="space-y-3">
              {[1, 2, 3].map((j) => (
                <div key={j} className="space-y-2">
                  <Skeleton className="h-3 w-1/3" />
                  <Skeleton className="h-4 w-full" />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </FullPageContent>
  );
}
